module.exports = __webpack_public_path__ + "static/media/neteler.5746aeee.svg";